import { faUser, faBuilding, faCalendarCheck, faAddressCard, faFileAlt, faClipboard } from '@fortawesome/free-regular-svg-icons'
import { faStethoscope, faChartLine, faDollarSign ,faGear, faHouseChimney, faUserEdit, faTriangleExclamation, faBoxesStacked } from '@fortawesome/free-solid-svg-icons'

// Itens do Menu lateral:

const menuItems = [
  {
    label: "Início",
    icon: faHouseChimney,
    view: "home",
    permissions: {
      systemAdm: true,
      companyAdm: true,
      professional: true,
      secretary: true
    },
  },

  {
    label: "Agenda",
    icon: faCalendarCheck,
    view: "calendar",
    permissions: {
      systemAdm: false,
      companyAdm: true,
      professional: true,
      secretary: true
    },
  },

  {
    label: "Pacientes",
    icon: faAddressCard,
    view: "patient",
    permissions: {
      systemAdm: false,
      companyAdm: true,
      professional: true,
      secretary: true
    },
  },

  {
    label: "Atendimentos",
    icon: faStethoscope,
    view: "attendance",
    permissions: {
      systemAdm: false,
      companyAdm: true,
      professional: true,
      secretary: true
    },
  },

  {
    label: "Pacotes de Atendimentos",
    icon: faBoxesStacked,
    view: "attendance-package",
    permissions: {
      systemAdm: false,
      companyAdm: true,
      professional: true,
      secretary: true
    },
  },

  {
    label: "Emissão de Documentos",
    icon: faFileAlt,
    view: "document-template",
    permissions: {
      systemAdm: true,
      companyAdm: true,
      professional: true,
      secretary: true
    },
  },

  {
    label: "Financeiro",
    icon: faDollarSign,
    view: "finance",
    permissions: {
      systemAdm: false,
      companyAdm: true,
      professional: false,
      secretary: false
    },
  },
  
  {
    label: "Relatórios",
    icon: faChartLine,
    view: "report",
    permissions: {
      systemAdm: false,
      companyAdm: true,
      professional: false,
      secretary: false
    },
  },

  {
    label: "Usuários",
    icon: faUser,
    view: "user",
    permissions: {
      systemAdm: true,
      companyAdm: true,
      professional: false,
      secretary: false
    },
  },

  {
    label: "Empresa",
    icon: faBuilding,
    view: "company",
    permissions: {
      systemAdm: false,
      companyAdm: true,
      professional: false,
      secretary: false
    },
  },

  {
    label: "Empresas",
    icon: faBuilding,
    view: "companies",
    permissions: {
      systemAdm: true,
      companyAdm: false,
      professional: false,
      secretary: false
    },
  },

  {
    label: "Registros de Auditoria (log)",
    icon: faClipboard,
    view: "log",
    permissions: {
      systemAdm: true,
      companyAdm: true,
      professional: false,
      secretary: false
    },
  },

  {
    label: "Erros",
    icon: faTriangleExclamation,
    view: "error",
    permissions: {
      systemAdm: true,
      companyAdm: false,
      professional: false,
      secretary: false
    },
  },

  {
    label: "Sistema",
    icon: faGear,
    view: "system",
    permissions: {
      systemAdm: true,
      companyAdm: false,
      professional: false,
      secretary: false
    },
  },

  {
    label: "Minha Conta",
    icon: faUserEdit,
    view: "my-account",
    permissions: {
      systemAdm: true,
      companyAdm: true,
      professional: true,
      secretary: true
    },
  },

]

// Logo do sistema (base64):

const systemLogo = "data:image/png;base64, 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"

export { menuItems, systemLogo }